import * as React from "react";
const SvgAccounts = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 6.35 6.35", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { transform: "translate(0 -290.65)", shapeRendering: "auto" }, /* @__PURE__ */ React.createElement("path", { d: "m0.23724 294.88c-0.13541 0.0135-0.23847 0.12758-0.23828 0.26367l3e-8 1.5876c-5.6203e-4 0.14693 0.11869 0.26618 0.26563 0.26562l4.7615 9.1e-4c0.14693 5.6e-4 0.26619-0.11869 0.26562-0.26562v-1.5876c-5.181e-4 -0.14617-0.11946-0.26423-0.26562-0.26367l-4.7615-9.1e-4c-0.009109-4.7e-4 -0.018235-4.7e-4 -0.027344 0zm0.29102 0.5293 4.2341 9.1e-4v1.0583l-4.2341-9.1e-4z", color: "#000000", colorRendering: "auto", dominantBaseline: "auto", imageRendering: "auto", "solid-color": "#000000", style: {
  fontFeatureSettings: "normal",
  fontVariantAlternates: "normal",
  fontVariantCaps: "normal",
  fontVariantLigatures: "normal",
  fontVariantNumeric: "normal",
  fontVariantPosition: "normal",
  isolation: "auto",
  mixBlendMode: "normal",
  shapePadding: 0,
  textDecorationColor: "#000000",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textIndent: 0,
  textOrientation: "mixed",
  textTransform: "none",
  whiteSpace: "normal"
} }), /* @__PURE__ */ React.createElement("path", { d: "m1.2965 292.77c-0.13541 0.0135-0.23847 0.12758-0.23828 0.26367l-9.115e-4 1.5875c-5.62e-4 0.14694 0.11869 0.26619 0.26563 0.26562l4.7616 1e-5c0.14693 5.6e-4 0.26619-0.11869 0.26562-0.26562l9.115e-4 -1.5875c-5.181e-4 -0.14617-0.11946-0.26423-0.26562-0.26367h-4.7616c-0.00911-4.7e-4 -0.018235-4.7e-4 -0.027344 0zm0.29102 0.5293h4.2342l-9.115e-4 1.0582-4.2342-1e-5z", color: "#000000", colorRendering: "auto", dominantBaseline: "auto", imageRendering: "auto", "solid-color": "#000000", style: {
  fontFeatureSettings: "normal",
  fontVariantAlternates: "normal",
  fontVariantCaps: "normal",
  fontVariantLigatures: "normal",
  fontVariantNumeric: "normal",
  fontVariantPosition: "normal",
  isolation: "auto",
  mixBlendMode: "normal",
  shapePadding: 0,
  textDecorationColor: "#000000",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textIndent: 0,
  textOrientation: "mixed",
  textTransform: "none",
  whiteSpace: "normal"
} }), /* @__PURE__ */ React.createElement("path", { d: "m0.23815 290.65c-0.13541 0.0135-0.23847 0.12758-0.23828 0.26367l-1.67e-9 1.5876c-5.6202e-4 0.14693 0.11869 0.26618 0.26563 0.26562h4.7616c0.14693 5.6e-4 0.26619-0.11869 0.26562-0.26562v-1.5876c-5.181e-4 -0.14617-0.11946-0.26423-0.26562-0.26367h-4.7616c-0.009109-4.7e-4 -0.018235-4.7e-4 -0.027344 0zm0.29102 0.5293h4.2342v1.0583h-4.2342z", color: "#000000", colorRendering: "auto", dominantBaseline: "auto", imageRendering: "auto", "solid-color": "#000000", style: {
  fontFeatureSettings: "normal",
  fontVariantAlternates: "normal",
  fontVariantCaps: "normal",
  fontVariantLigatures: "normal",
  fontVariantNumeric: "normal",
  fontVariantPosition: "normal",
  isolation: "auto",
  mixBlendMode: "normal",
  shapePadding: 0,
  textDecorationColor: "#000000",
  textDecorationLine: "none",
  textDecorationStyle: "solid",
  textIndent: 0,
  textOrientation: "mixed",
  textTransform: "none",
  whiteSpace: "normal"
} })));
export default SvgAccounts;
